import { useQuery } from '@tanstack/react-query';
import { SWARD_ONLY } from 'src/utils/marketsAndNetworksConfig';

export function useCoingeckoCategories() {
  return useQuery({
    queryFn: async () => {
      // Categories are only optional UI filters. A static Sward deployment has
      // no Next.js API runtime, so do not make the Pro CoinGecko request.
      if (SWARD_ONLY) {
        return { uniqueSymbolsStablecoins: [], uniqueSymbolsEth: [] };
      }
      const response = await fetch('/api/coingecko-categories');
      if (!response.ok) throw new Error('Failed to fetch CoinGecko categories');
      return await response.json();
    },
    queryKey: ['coingecko-categories'],
    staleTime: 1000 * 60 * 60 * 24 * 7,
    refetchOnWindowFocus: false,
    select: (data) => {
      return {
        stablecoinSymbols: data.uniqueSymbolsStablecoins || [],
        ethCorrelatedSymbols: data.uniqueSymbolsEth || [],
      };
    },
  });
}
